import { AxiosRequestConfig } from "axios";
import { v4 as uuid } from "uuid";
import { claimsSearchRequestType } from "../types/Chorus/claimsSearch";
import { upsertUserApiRequest } from "types/UserManagement/User";

const GET = "GET";
const POST = "POST";
const PUT = "PUT";
const DELETE = "DELETE";

export const baseUrl = process.env.REACT_APP_BASE_URL;
const metaDataUrl = "/ClaimMetadata/v1";
const claimSearchUrl = "/ClaimSearch/v1";
const claimTrackinghUrl = "/ClaimTracking/v1";
const assignUserUrl = "/AssignClaimMetadata/v1";

//Remove when Kontent API for Base is stood up
export const CABaseUrl = process.env.REACT_APP_CA_BASE_URL;

export const postCodeApi = (zipCode: string) => ({
  headers: {
    TransactionId: uuid(),
  },

  method: GET,
    url: `${baseUrl}/AddressService/v2/${zipCode}`
});

export const companyDetailApi = ()=>({
  headers: {
    TransactionId: uuid(),
  },
  url: `${baseUrl}/CompanyDetail/v1`,
  method: GET,
});

export const claimsListApi = () => {
  return {
    url: `${baseUrl}/ClaimList/v1`,
    headers: {
      TransactionId: uuid(),
    },
    method: GET,
  };
};

export const deleteClaimApi = (
  claimId: string,
  companyId: string,
): AxiosRequestConfig => {
  return {
    url: baseUrl + metaDataUrl,
    data: {
      claimId,
      companyId,
    },
    method: DELETE,
  };
};

export const saveGIPClaimPage1 = ()=>({
  headers: {
    TransactionId: uuid(),
  },
  url: baseUrl + metaDataUrl,
  method: POST,
});

export const updateClaimSummary = ()=> ({
  headers: {
    TransactionId: uuid(),
  },
  url: baseUrl + metaDataUrl,
  method: PUT,
});

export const getGIPClaim = (claimId: string)=> ({
  headers: {
    TransactionId: uuid(),
    ClaimId: claimId,
  },
  url: baseUrl + metaDataUrl,
  method: GET,
});

export const getBespokeQuestionsApi = (productType: string) => ({
  headers: {
    TransactionId: uuid(),
    SelectedProduct: productType,
  },
  url: `${baseUrl}/BespokeQuestions/v1`,
  method: GET,
});

const documentURL = baseUrl + "/Documents/v1";
export const uploadDocument = (
  data: {
    claimId: string;
    documentId: string;
    documentName: string;
    documentData: any;
  },
  onUploadProgress: (progressEvent: any) => void,
) => {
  const formData = new FormData();
  const headers = {
    TransactionID: uuid(),
    claimId: data.claimId,
    documentId: data.documentId,
    fileName: data.documentName,
  };
  formData.append("DocumentData", data.documentData);

  return {
    url: baseUrl + "/Documents/v1",
    method: POST,
    onUploadProgress,
    headers: {
      ...headers,
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  };
};

export const uploadAWDDoc = (
  data: {
    claimId: string;
    documentId: string;
    documentName: string;
    documentData: any;
  },
  claimHeaders: {
    claimId: string;
    lifeId: string;
    policyNo: string;
    productType: string;
  },
  onUploadProgress: (progressEvent: any) => void,
) => {
  const formData = new FormData();

  formData.append("DocumentData", data.documentData);
  //Using the below URL for testing. Will be removed and used actual one once deployment is done.
  return {
    timeout: 60000,
    url: baseUrl + "/AWDClaimWorkItem/v1",
    method: PUT,
    onUploadProgress,
    headers: {
      documentId: data.documentId,
      fileName: data.documentName,
      "Content-Type": "multipart/form-data",
      ...claimHeaders,
      requestType: "DocumentUpload",
      TransactionID: uuid(),
    },
    data: formData,
  };
};

export const deleteDocument = (documentId: string, claimId: string) => {
  return {
    url: documentURL,
    method: DELETE,
    data: {
      transactionId: uuid(),
      documentId,
      claimId,
    },
  };
};
export const getDocument = (claimId: string) => ({
  url: documentURL,
  method: GET,
  headers: {
    TransactionId: uuid(),
    ClaimId: claimId,
  },
});

export const getClaimStatusHistory = (body: any) => ({
  url: `${baseUrl}/ClaimSearch/v1`,
  method: POST,

  data: body,
});

//This API is re-usable for multiple claims tracking requests
export const claimSearchAPI = (data: claimsSearchRequestType) => {
  return {
    url: baseUrl + claimSearchUrl,
    method: POST,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      ...data,
      transactionId: uuid(),
    },
  };
};

export const getClaimTracking = (
  lifeId: string,
  claimId: string,
  selectedPolicyNumber: string,
) => ({
  url: baseUrl + claimTrackinghUrl,
  method: GET,
  headers: {
    TransactionId: uuid(),
    LifeId: lifeId,
    ClaimId: claimId,
    SelectedPolicyNumber: selectedPolicyNumber,
  },
});

export const submitClaim = (data: {
  claimId: string;
  policyNo: string;
  productTypeModel: string;
  requestTypeModel: string;
}) => ({
  url: baseUrl + "/AWDClaimWorkItem/v1",
  method: POST,
  data: {
    ...data,
    transactionId: uuid(),
  },
});

export const getPrivilegedUsersApi = ()=>( {
  headers: {
    TransactionId: uuid(),
  },
  url: `${baseUrl}/PrivilegedUsers/v1`,
  method: GET,
});

export const getAllUsersApi = ()=>( {
  headers: {
    TransactionId: uuid(),
  },
  url: `${baseUrl}/UserPolicies/v1`,
  method: GET,
});

export const assignUserPostApi = (data: any) => ({
  url: baseUrl + assignUserUrl,
  method: POST,
  data: {
    ...data,
    transactionId: uuid(),
  },
});

export const assignUserPutApi = (data: any) => ({
  url: baseUrl + assignUserUrl,
  method: PUT,
  data: {
    ...data,
    transactionId: uuid(),
  },
});

export const getCMSData = ()=>({
  headers: {
    TransactionId: uuid(),
  },
  url: `${baseUrl}/KontentAi/v1`,
  method: GET,
});

export const getUnumUkCMSData = (params?: {}) => ({
  headers: {
    TransactionId: uuid(),
  },
  params,
  url: `${baseUrl}/KontentAiUnumUk/v1`,
  method: GET,
});


export const getPowerBiEmbedUrl = (reportId: string) => {
  return {
    method: GET,
    url: `${baseUrl}/Reporting/v1`,
    headers: {
      Reportkey: reportId,
      ApplicationName: "EmployerPortal",
      TransactionId: uuid(),
    },
  };
};
export const getChatToken = ()=>({
  headers: {
    TransactionId: uuid(),
  },
  url: `${baseUrl}/Chat/Token/v1`,
  method: GET,
});

export const getCompanyProductsByUser = () => ({
  headers: {
    TransactionId: uuid(),
  },
  url: `${baseUrl}/CompanySettings/Products/v1`,
  method: GET,
});

export const checkFeatureFlag = (data: any) => ({
  url: baseUrl + "/FeatureFlag/Check/v1",
  method: POST,
  data: {
    ...data,
    transactionId: uuid(),
  },
});

export const getUserDetails = ()=>({
  headers: {
    TransactionId: uuid(),
  },
  url: `${baseUrl}/GetUserDetails/v1`,
  method: GET,
});

export const getUsersByToken = ()=>({
  headers: {
    TransactionId: uuid(),
  },
  url: `${baseUrl}/User/GetUsers/v1`,
  method: GET,
});

// update data to be correct type
export const upsertUser = (
  data: upsertUserApiRequest,
  type: "update" | "create",
): AxiosRequestConfig => ({
  data: {
    ...data,
    TransactionId: uuid(),
  },
  url: `${baseUrl}/User/${type === "create" ? "Create/v1" : "Update/v1"}`,
  method: type === "create" ? POST : PUT,
});

export const CheckEmail = (EmailAddress: string) => ({
    url: baseUrl + "/User/GetUserByEmail/v1",
    method: POST,
    data: {
      EmailAddress,
        transactionId: uuid(),
    },
});

export const getUsersTncStatus = () => ({
  headers: {
    TransactionId: uuid(),
  },
  url: `${baseUrl}/GetTnCAcceptance/v1`,
  method: GET,
});

export const postAcceptTnc = (thumbprint: string): AxiosRequestConfig => ({
  data: { thumbprint: thumbprint, transactionId: uuid() },
  url: `${baseUrl}/UpsertUserTnC/v1`,
  method: POST,
});
